import React from 'react'
import cn from 'classnames'
import Gradient from 'react-avatar-editor'
import { currencyFormat, percentageFormat, priceColor } from '../../core/helpers'

import PriceBackground from './price-change-bg.svg'
import PriceGradient from './price-change-gradient.svg'
import LoaderValue from '../Loader/LoaderValue'

function OverviewMarketCap({ marketCap, marketCapDiff24h }) {
  return (
    <div className="rounded-xl h-full border-0 overflow-hidden" style={{ backgroundColor: '#13151a' }}>
      <div className="grid grid-cols-2 h-full">
        <div>
          <div className="p-4 h-full pr-0 flex flex-col justify-between">
            <div className="text-grey md:text-xl sm:text-sm md:pb-5 pb-1">
              Total Market Cap
            </div>
            <div className="flex">
              <div>
                <div className="text-5xl text-oz md:font-semibold sm:font-medium uppercase">
                  {marketCap
                    ? currencyFormat(marketCap, { average: true, totalLength: 3 })
                    : <LoaderValue width="120" height="35" />}
                </div>
                <div className={cn('text-xl', priceColor(marketCapDiff24h))}>
                  {marketCapDiff24h ? percentageFormat(marketCapDiff24h) : <LoaderValue width="100" height="20" />}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="flex h-full p-4 pl-0">
            <div className="flex w-full h-full relative">
              <img src={PriceBackground} className="absolute h-full left-0" alt="" />
              <Gradient
                className="absolute h-full right-0 rounded-full"
                style={{ width: 'unset' }}
                position={{ x: changeX(marketCapDiff24h), y: 0 }}
                image={PriceGradient}
                border={0}
                borderRadius={100}
                scale={1}
                rotate={0}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function changeX(value) {
  const middle = 0.5

  if (!value) {
    return middle
  }

  const multiplier = 3
  const number = Math.min(Math.max(value * multiplier, -100), 100)

  return middle + (-number / 100 * middle)
}

export default OverviewMarketCap
